import { events } from '@/services/wss/SystemEvents';
import ComponentNotifier from '@/services/wss/ComponentNotifier';
import WssEventHandlerBase from '@/services/engines/WssEventHandlerBase';

const _name = 'NotificationEngine';

class NotificationEngine extends WssEventHandlerBase {
    _name = _name;

    bootup() {
        super.bootup();
        this.clear();

        this._unsub = this._wsNotifier.subscribe(events.OnNotificationPublished, this.onMessage);
    }

    clear() {
        super.clear();

        if (this._unsub) this._unsub();
    }

    /**
     * Receives a pushed notification, already deserialized by WssEventNotifier.
     * @param {{traceId: string, receiver: string, message: string, data: string, targets: string, category: string, createdOn: number}} n
     */
    onMessage = (n) => {
        try {
            // receiver filter follows once the broadcast value is known
            this.logDebug('onMessage', JSON.stringify(n));
            ComponentNotifier.notify(_name, 'notificationReceived', n);
        } catch (error) {
            this.logError('onMessage', error.message);
        }
    };
}

const notificationEngine = new NotificationEngine();
export default notificationEngine;
